import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, Grid, Divider, Link as MuiLink } from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const legalLinks = [
    { label: 'Terms of Service', path: '/terms' },
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Cookie Policy', path: '/cookie-policy' },
    { label: 'Security', path: '/security' },
    { label: 'Data Retention', path: '/data-retention' },
    { label: 'Accessibility', path: '/accessibility' },
    { label: 'Compliance', path: '/compliance' }
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#1a202c',
        color: '#a0aec0',
        py: 4,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}>
              AppealBot
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Automating insurance appeals for small medical practices. Save time, reduce
              administrative burden, and increase revenue recovery.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}>
              Legal & Policies
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {legalLinks.slice(0, 4).map((link) => (
                <MuiLink
                  key={link.path}
                  component={Link}
                  to={link.path}
                  sx={{
                    color: '#a0aec0',
                    textDecoration: 'none',
                    '&:hover': { color: 'white' },
                    fontSize: '0.875rem'
                  }}
                >
                  {link.label}
                </MuiLink>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}>
              Trust & Compliance
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {legalLinks.slice(4).map((link) => (
                <MuiLink
                  key={link.path}
                  component={Link}
                  to={link.path}
                  sx={{
                    color: '#a0aec0',
                    textDecoration: 'none',
                    '&:hover': { color: 'white' },
                    fontSize: '0.875rem'
                  }}
                >
                  {link.label}
                </MuiLink>
              ))}
            </Box>
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                HIPAA Compliant
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: '#2d3748' }} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
            &copy; {currentYear} AppealBot, Inc. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <MuiLink
              href="mailto:support@appealbot.com"
              sx={{ color: '#a0aec0', textDecoration: 'none', '&:hover': { color: 'white' }, fontSize: '0.875rem' }}
            >
              Contact Support
            </MuiLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
